@if (value(); as val) {
  <span>
    {{ val | date: dateFormats.ShortFormFullDate }}
  </span>
}
